import { createContext, useContext } from 'react';

type ModalCallbackData = Record<string, unknown> | string | number | boolean;

interface ModalContext {
  isOpen: (name: string) => boolean;
  openModal: (name: string, callbackData?: ModalCallbackData) => void;
  closeModal: (name: string) => void;
  getCallbackData: (name: string) => unknown | undefined;
}

export const ModalContext = createContext<ModalContext | undefined>(undefined);
const errorMessage = 'useModalContext must be used within a Modal provider!';

export const useModalContext = (): ModalContext => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error(errorMessage);
  }

  return context;
};
